'use client';

import React, { Dispatch, SetStateAction, useState } from 'react';
import { motion, useMotionValue } from 'framer-motion';
import { problemsData } from '@/consts';

const DRAG_BUFFER = 50;

const SPRING_OPTIONS = {
  type: 'spring',
  mass: 3,
  stiffness: 400,
  damping: 50
};

export const SwipeCarousel = () => {
  const [blockIndex, setBlockIndex] = useState(0);
  const dragX = useMotionValue(0);

  const onDragEnd = () => {
    const x = dragX.get();
    if (x <= -DRAG_BUFFER && blockIndex < problemsData.length - 1) {
      setBlockIndex((prev) => prev + 1);
    } else if (x >= DRAG_BUFFER && blockIndex > 0) {
      setBlockIndex((prev) => prev - 1);
    }
  };

  return (
    <div className="relative overflow-hidden md:py-8">
      <motion.div
        drag="x"
        dragConstraints={{ left: 0, right: 0 }}
        style={{ x: dragX }}
        animate={{
          translateX: `calc(-${blockIndex * 296}px)`
        }}
        transition={SPRING_OPTIONS}
        onDragEnd={onDragEnd}
        className="flex cursor-grab items-center active:cursor-grabbing"
      >
        <CarouselBlocks blockIndex={blockIndex} />
      </motion.div>

      <Dots blockIndex={blockIndex} setBlockIndex={setBlockIndex} />
    </div>
  );
};

const CarouselBlocks = ({ blockIndex }: { blockIndex: number }) => {
  return (
    <>
      {problemsData.map((block, idx) => (
        <motion.div
          key={idx}
          animate={{
            scale: blockIndex === idx ? 0.95 : 0.85,
            backgroundColor: blockIndex === idx ? '#009E3E30' : '#009E3E20'
          }}
          transition={SPRING_OPTIONS}
          className={`bg-opacity-30 text-white p-6 rounded-2xl flex flex-col divide-y z-20s`}
        >
          <div className="w-[250px]">
            <div className="flex flex-row border-b border-white justify-between gap-2 items-center pb-1">
              <h3 className="md:text-H4 text-h4 font-bold">{block.title}</h3>
              <div className="scale-75">
                <block.Icon />
              </div>
            </div>
            <div className="py-8 h-1/2">
              <p className="mr-4 md:text-T text-t">
                {block.description.map((line, lineIndex) => (
                  <React.Fragment key={lineIndex}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </p>
            </div>
          </div>
        </motion.div>
      ))}
    </>
  );
};

const Dots = ({
  blockIndex,
  setBlockIndex
}: {
  blockIndex: number;
  setBlockIndex: Dispatch<SetStateAction<number>>;
}) => {
  return (
    <div className="mt-4 flex w-full justify-center gap-2">
      {problemsData.map((_, idx) => (
        <button
          key={idx}
          onClick={() => setBlockIndex(idx)}
          className={`h-3 w-3 rounded-full transition-colors ${
            idx === blockIndex ? 'bg-[#009E3E]' : 'bg-neutral-500'
          }`}
        />
      ))}
    </div>
  );
};
